import { useSandboxPreviewStore } from '@/previewStore';
import { resolveShellPostMessageTarget } from '@/bridge/shellOrigin';
import {
  SandboxMessageType,
  type BlockSelectMessage,
  type EditTarget,
} from '@web-studio/shared-schemas';

/** Notify studio-shell when the user clicks a block or child field in the preview canvas. */
export function postBlockSelectToShell(blockId: string, editTarget?: EditTarget): void {
  if (typeof window === 'undefined' || window.parent === window) {
    return;
  }
  // Apply selection immediately — inner media outlines are clipped by overflow:hidden parents.
  useSandboxPreviewStore.getState().setActiveBlockId(blockId, editTarget ?? null);
  const message: BlockSelectMessage = {
    type: SandboxMessageType.BLOCK_SELECT,
    blockId,
    ...(editTarget ? { editTarget } : {}),
  };
  window.parent.postMessage(message, resolveShellPostMessageTarget());
}
